<template>
  <div>
    <label v-for="(option, index) in programs" class="mt-checkbox mt-checkbox-outline"
           :class="{'disabled' : option.status === 0}"
           v-show="!isValueHidden(option.label)">{{ option.name }}
      <input :name="field.name+'-'+index"
             type="checkbox"
             :id="option.name"
             :value="option.id"
             :checked="value.includes(option.id.toString())"
             :disabled="locked || option.status === 0"
             @change="toggleValue(option.id.toString())"
      />
      <span></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    hiddenValues: {
      type: Array,
      default: () => [],
    },
    programs: {
      type: Array,
      default: () => [],
    }
  },

  emits: ['input'],

  setup(props, { emit }) {
    const toggleValue = (value) => {
      if (props.value.includes(value)){
        emit('input', props.value.filter(v => v !== value))
      } else {
        emit('input', [value, ...props.value])
      }
    }

    const isValueHidden = (value) => {
      if (props.hiddenValues) {
        return props.hiddenValues.some(h => {
          return h.field === props.field.name && value === h.value
        })
      }
      return false;
    }

    return {
      isValueHidden,
      toggleValue,
    }
  }
}
</script>

<style scoped lang="scss">
.mt-checkbox {
  display: block;
}

.mt-checkbox-outline {
  display: block;
}
</style>



// WEBPACK FOOTER //
// ProgramCheckboxRender.vue?2cbcbdd8